export default "__VITE_ASSET__eaa8cd18__"